import PropTypes from 'prop-types';
import React from 'react';
import ConfirmPasswordFormField from './ConfirmPasswordFormField.jsx';
import generalComplexityRule from './generalComplexityRule.js';
import languagesPropType from './languagesPropType.js';
import minimumCharacterRule from './minimumCharacterRule.js';
import NewPasswordFormField from './NewPasswordFormField.jsx';
import passwordAnalyzer from './passwordAnalyzer.js';
import PasswordStrengthMeter from './PasswordStrengthMeter.jsx';
import styles from './FormView.css';
import translate from './translate.js';

class FormView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmPassword: props.confirmPassword,
      showPasswordMeter: false,
    };
  }

  render() {
    let {
      language,
      onChange,
      password,
      rules,
      tabIndex,
    } = this.props;
    let {
      confirmPassword,
      showPasswordMeter,
    } = this.state;
    let {
      rulesResults,
      strengthScore,
    } = passwordAnalyzer(password, rules);

    return (
      <div>
        <div
          style={{
            display: 'flex',
          }}
        >
          <NewPasswordFormField
            formFieldProps={{
              className: styles.formField,
            }}
            inputProps={{
              className: styles.textInput,
              tabIndex,
              onBlur: () => this.setState({ showPasswordMeter: false }),
              onFocus: () => this.setState({ showPasswordMeter: true }),
            }}
            label={<span><span className="required">* </span> {translate('password', language)}</span>}
            language={language}
            onChange={password =>  {
              onChange(password, this.state.confirmPassword);
              this.validateConfirmPasswordField();
            }}
            rulesResults={rulesResults}
            value={password}
          />

          {
            showPasswordMeter &&
            <div
              style={{
                position: 'relative',
              }}
            >
              <div
                style={{
                  backgroundColor: '#fff',
                  boxShadow: '0 7px 9px rgba(0,0,0,.3)',
                  position: 'absolute',
                  width: 400,
                  zIndex: 9999,
                }}
              >
                <PasswordStrengthMeter
                  language={language}
                  rulesResults={rulesResults}
                  strengthScore={strengthScore}
                />
              </div>
            </div>
          }
        </div>

        <ConfirmPasswordFormField
          formFieldProps={{
            className: styles.formField,
          }}
          inputProps={{
            className: styles.textInput,
            tabIndex: ++tabIndex,
          }}
          label={<span><span className="required">* </span> {translate('confirm', language)}</span>}
          language={language}
          newPassword={password}
          onChange={confirmPassword => {
            this.setState({
              confirmPassword,
            });
            onChange(this.props.password, confirmPassword);
          }}
          onSetValidate={validate =>  this.validateConfirmPasswordField = validate}
          value={confirmPassword}
        />
      </div>
    );
  }
}

FormView.defaultProps = {
  confirmPassword: '',
  language: languagesPropType.defaultProp,
  password: '',
  rules: [
    minimumCharacterRule(8),
    generalComplexityRule(),
  ],
  tabIndex: 1,
};

FormView.propTypes = {
  confirmPassword: PropTypes.string,
  language: languagesPropType.propType,
  password: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      test: PropTypes.func.isRequired,
    })
  ),
  tabIndex: PropTypes.number,
};

export default FormView;